import ApiService from "@services/api.service";
import { Notify} from 'quasar'

export const etudiantHistoriqueEntreprise = {
  state: {
    historique: null,
    historiques: [],
  },
  mutations:{
    setHistorique(state, historique){
      state.historique = historique;
    },
    setHistoriques(state, historiques){
      state.historiques = historiques;
    },
    callbackDeleteHistorique(state, historique){
      for (let inscription in state.historiques) {
        if (state.historiques[inscription].id === historique) {
          state.historiques.splice(historique, 1)
        }
      }
    },
  },
  actions: {
    async fetchEtudiantHistoriqueEntreprise(context, idEtudiant){
      try{
        const response = await ApiService.getRequest(`etudiant_contrat_historiques?etudiant=${idEtudiant}`);
        context.commit('setHistoriques', response.data['hydra:member']);
      }catch(error){
        console.error(error);
        Notify.create({
          message: 'Une erreur s\'est produite',
          color: 'red',
        })
      }
    },
    async addEtudiantHistoriqueEntreprise(context, formData){
      try{
        const response = await ApiService.postRequest(`etudiant_contrat_historiques`, formData);
        context.commit('setHistorique', response.data);
        Notify.create({
          message: "La démarche à été enregistrée avec succès",
          color:'green',
        });
      }catch(error){
        console.error(error);
        Notify.create({
          message:"Une erreur s'est produite",
          color:'red'
        })
      }
    },
    async updateEtudiantHistoriqueEntreprise(context, { id, data }) {
      try {
        const response = await ApiService.patchRequest(`etudiant_contrat_historiques/${id}`, data);
          context.commit('setHistorique', response.data);
          Notify.create({
            message: "La démarche à été enregistrée avec succès",
            color:'green',
          });
        return response.data;
      } catch (error) {
        console.error(error);
        Notify.create({
          message:"Une erreur s'est produite",
          color:'red'
        });
      }
    },
    async updateStatusHistorique(context, data){
      try{
        const response = await ApiService.patchRequest(data.id, {etat: data.etat});
        context.commit('setHistorique', response);
        Notify.create({
          message: "Le status a été modifié avec succès",
          color:'green',
        });
        return response;
      }catch(e){
        console.error(e);
        Notify.create({
          message:"Une erreur s'est produite",
          color:'red'
        });
      }
    },
    deleteHistorique(context, historique){
      try {
        const response = ApiService.deleteRequest(historique);
        context.commit('callbackDeleteHistorique', response);

        Notify.create({
          message: 'Supprimé avec succès',
          color: 'green'
        });
      }catch (e) {
        console.error(e);
        Notify.create({
          message:"Une erreur s'est produite",
          color:'red'
        });
      }
    }
  },
  getters: {
    getHistoriques(state){
      return state.historiques;
    },
    getHistorique(state){
      return state.historique;
    }
  }
}
